// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2488":"da2f8af5","6178":"247b1f85","8927":"f6849665"}[chunkId] + ".chunk.css";
};